import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const StickyQuoteCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const location = useLocation();

  const showOnPaths = ["/products", "/services"];
  const shouldShow = showOnPaths.some(p => location.pathname.startsWith(p)) && !location.pathname.includes("/customization");

  useEffect(() => {
    if (!shouldShow || isDismissed) return;

    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [shouldShow, isDismissed]);

  if (!shouldShow || isDismissed) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-[45] border-t border-border/50 bg-card/95 backdrop-blur-lg shadow-[0_-4px_20px_hsl(var(--background)/0.5)]"
        >
          <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-4">
            <p className="text-sm md:text-base text-foreground font-medium hidden sm:block">
              Need a fleet quote? <span className="text-muted-foreground">Get pricing in 24h</span>
            </p>
            <p className="text-sm text-foreground font-medium sm:hidden">
              Get fleet pricing in 24h
            </p>
            <div className="flex items-center gap-2">
              <Button size="sm" asChild className="bg-gradient-to-r from-eco-green to-teal-bright hover:from-eco-green-light hover:to-teal-bright text-white shadow-lg shadow-eco-green/20">
                <Link to="/contact">
                  <MessageSquare className="w-4 h-4 mr-1.5" />
                  Request Quote
                </Link>
              </Button>
              <button
                onClick={() => setIsDismissed(true)}
                className="p-1.5 rounded-full text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
                aria-label="Dismiss"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyQuoteCTA;
